import { Contents } from "./../../components/Contents/Contents";
import { DataContext } from "./../../context/DataContext";
import { Footer } from "./../../components/Footer/Footer";
import { useParams } from "react-router-dom";
import { useResetScroll } from "./../../hooks/useResetScroll";
import React from "react";

export const Page = () => {
	const { slug } = useParams();
	const pages = React.useContext(DataContext).pages;
	const page = pages && pages.find((page) => page.slug === slug);
	useResetScroll();

	return (
		<React.Fragment>
			<div className={`page`}>
				{page && page.acf.content && <Contents contents={page.acf.content} />}
			</div>
			<Footer />
		</React.Fragment>
	);
};
